import { CSSProperties } from 'react';
import { isVideoSource } from '../../shared/utils/media';

export default function PreviewMedia({ src, mimeType, alt, style }: {
  src: string;
  mimeType?: string;
  alt: string;
  style?: CSSProperties;
}) {
  return mimeType?.startsWith('video/') || isVideoSource(src)
    ? <video src={src} controls playsInline preload="metadata" style={style} />
    : <img src={src} alt={alt} style={style} />;
}
